<script>
export default {
	props: {
		order: Object,
	},
	data() {
		return {
			tokensByAfiliado: [],
			recetas: [],
			loading: true,
		}
	},
	methods: {
		async reloadRecetas() {
			let recetasIds = this.order.items
				.filter((x) => x.customization?.key == 'recetadigital')
				.map((x) => x.customization.data.recetaId)

			const response = await this.$shopApi.post({
				url: '/recetadigital/checkout/load-recetas-by-ids',
				loading: (v) => (this.loading = v),
				data: {
					recetasIds,
				},
			})

			if (response.success) {
				this.recetas = response.data.recetas || []
				this.tokensByAfiliado = this.recetas.reduce((tokensByAfiliado, receta) => {
					let obj = tokensByAfiliado.find(
						(x) => x.financiadorKey == receta.financiadorKey && x.nroAfiliado == receta.nroAfiliado
					)
					if (!obj) {
						obj = {
							financiadorKey: receta.financiadorKey,
							financiadorName: receta.financiador.displayName,
							nroAfiliado: receta.nroAfiliado,
							recetas: [],
						}
						tokensByAfiliado.push(obj)
					}
					receta.items = this.order.items.filter((x) => {
						return (
							x.customization?.key == 'recetadigital' && x.customization.data?.recetaId == receta.id
						)
					})
					obj.recetas.push(receta)
					return tokensByAfiliado
				}, [])
			}
		},
	},
	mounted() {
		this.reloadRecetas()
	},
}
</script>

<template>
	<div v-if="loading" class="w100 d-flex pa-6 justify-center align-center">
		<v-progress-circular indeterminate color="primary" />
	</div>

	<div v-else>
		<div class="d-flex flex-column" style="gap: 32px">
			<div
				v-for="(obj, i) of tokensByAfiliado"
				:key="`afiliado-${i}`"
				class="d-flex flex-column"
				style="gap: 12px"
			>
				<div>
					<b class="font-1">Afiliado&nbsp;</b>
					<b class="font-2">{{ obj.financiadorName }} / {{ obj.nroAfiliado }}</b>
				</div>
				<div
					class="w100 grey lighten-4 rounded-lg px-4 py-2"
					v-for="(receta, j) of obj.recetas"
					:key="`receta-${i}-${j}`"
				>
					<div class="d-flex align-center pb-2">
						<b>Receta #{{ receta.nroReceta }}</b>
						<v-spacer />
						<div class="font-0 success--text">
							<b>Validada</b>
						</div>
					</div>
					<table class="recetas-items-table w100">
						<tbody>
							<tr v-for="(item, k) of receta.items" :key="`item-${i}-${j}-${k}`">
								<td class="pa-2">x{{ item.qty }}</td>
								<td class="w100 pa-2">
									{{ item.name }}
									<div class="grey--text font-0">{{ item.variantName }}</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.recetas-items-table {
	td {
		vertical-align: top;
		border-top: 1px solid #ccc;
	}
}
</style>

